import { DataTable, Flex, Text } from '@raystack/apsara';
import _ from 'lodash';

import { COLORMAP_FACTORY } from '@src/components/Custom/ColorScale';
import { LinearGradientColorScale } from '@src/components/Custom/DynamicColorScale';
import styles from '@src/components/Custom/ModelCommonComponents/CDCommonComponents/styles.module.css';
import { Indices, colormaps } from '@src/utils/IndiceUtils';
import { rangeGenerator } from '@src/utils/commonUtils';
import { COLORMAP_TYPES } from '@src/utils/constants/APP';
import { getRasterVisualisationColorLegends } from '@src/utils/workFlowUtils';

const RasterColorInfo = ({ layer = {} }) => {
  const {
    type = '',
    colormap = '',
    buckets = {},
    rescale = []
  } = getRasterVisualisationColorLegends(layer) || {};
  const classData = Object.entries(buckets).map(([key, value]) => ({
    name: key,
    color: value
  }));

  const { indice_id = '' } = layer;

  if (indice_id) {
    const selectedPresetIndice = Indices.find(i => i.id === indice_id);
    const presetColorMap = colormaps[indice_id] || '';

    // for preset indices
    if (selectedPresetIndice && presetColorMap) {
      const GradientFunction =
        COLORMAP_FACTORY[colormap] || COLORMAP_FACTORY['spectral'];
      const colorGradientData = [...GradientFunction('range')];
      const range = decodeURIComponent(selectedPresetIndice.rescale).split(',');
      const ticks = rangeGenerator(Number(range[0]), Number(range[1]), 5);
      return (
        <Flex direction='column' gap='small'>
          <Text size={1} weight={400} variant='secondary'>
            Layer Scale
          </Text>
          <LinearGradientColorScale
            ticks={ticks}
            continuousColor={colorGradientData}
          />
        </Flex>
      );
    }
    return null;
  }

  if (type === COLORMAP_TYPES.rangeColormap) {
    const GradientFunction = COLORMAP_FACTORY[colormap];
    const colorGradientData = [...GradientFunction('range')];
    const range = rescale || [-1, 1];
    const ticks = rangeGenerator(Number(range[0]), Number(range[1]), 5);
    return (
      <Flex direction='column' gap='small'>
        <Text size={1} weight={400} variant='secondary'>
          Layer Scale
        </Text>
        <LinearGradientColorScale
          ticks={ticks}
          continuousColor={colorGradientData}
        />
      </Flex>
    );
  } else if (
    type === COLORMAP_TYPES.discreteColormap &&
    !_.isEmpty(classData)
  ) {
    const columns = [
      {
        header: 'Class names',
        accessorKey: 'name',
        cell: ({ row: { original: item } }) => (
          <Flex>
            <div
              className={styles.filledBox}
              style={{
                backgroundColor: `${item.color}`
              }}
            />
            <Text>{item.name}</Text>
          </Flex>
        )
      }
    ];
    return (
      <DataTable columns={columns} data={classData}>
        <DataTable.Content />
      </DataTable>
    );
  }
};

export default RasterColorInfo;
